export enum SymbolType {
  Knot = 0,
  List = 1,
  ListItem = 2,
  Var = 3,
  SubFlowAndWeave = 4,
  Arg = 5,
  Temp = 6,
}
